<template>
  <transition name="fade">
    <div
      v-if="loading"
      class="bell-loading"
      :class="{ 'center' : center }"
    >
      <img
        :width="width"
        src="https://www.phila.gov/assets/images/city-loading-occillate.gif"
      >
      <div>{{ message }}</div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "LoadingInline",
  props: {
    center: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "30px",
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
  .bell-loading {
    &.center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 99999;
    }
    img {
      vertical-align: middle;
      display: inline-block;
    }
    div {
      display: block;
    }
  }
  .fade-enter-active {
    transition: opacity .25s;
  }
  .fade-leave-active {
    transition: opacity .15s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>